// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"Backdrop_Backdrop__3j6VK","animate":"Backdrop_animate__36yIO"};